import {
  Box,
  ControlBar,
  IconButton,
  Tooltip,
  GridFilterModel,
  GridPreferencePanelsValue,
  Divider,
  useGridApiContext7,
  GridToolbarFilterButton7 as GridToolBarFilterButton,
  Button,
} from "@platform/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faFilterSlash,
  faFolderUser,
  faFolderXmark,
  faFolderCheck,
} from "@fortawesome/sharp-regular-svg-icons";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import React, { Dispatch, SetStateAction } from "react";
import { collectGAEvent } from "@platform/core";
import { ActionEnum } from "../models/ReasonsAndResolutions";

interface WorkItemControlBarProps {
  setFilterButtonEl?: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  isFilterOn: Boolean;
  setQueryServer: Dispatch<SetStateAction<boolean>>;
  queryServer: boolean;
  initialFilterState: GridFilterModel;
  filterModel: GridFilterModel;
  massActionClick: (changeAction: string) => void;
  showMassActionIcons: boolean;
}

export function WorkItemControlBar({
  isFilterOn,
  setQueryServer,
  queryServer,
  initialFilterState,
  filterModel,
  massActionClick,
  showMassActionIcons,
}: WorkItemControlBarProps) {
  const apiRef = useGridApiContext7();
  const [hasFilterValues, setHasFilterValues] = React.useState(
    filterModel.items.length > 0 &&
      filterModel.items.every(
        (item) =>
          item.value?.trim() !== "" && item.value !== undefined && item.value !== "Invalid Date"
      )
  );

  React.useEffect(() => {
    const hasValues =
      filterModel.items.length > 0 &&
      filterModel.items.every(
        (item) =>
          item.value?.trim() !== "" && item.value !== undefined && item.value !== "Invalid Date"
      );
    setHasFilterValues(hasValues);
  }, [filterModel]);

  const handleFilterClick = async () => {
    setQueryServer(true);
  };

  return (
    <ControlBar
      leftSlotComponents={
        <>
          <GridToolBarFilterButton
            slotProps={{
              button: {
                sx: { border: "none", outline: "none" },
                "aria-label": "Filter",
                onClick: () => {
                  const panel = apiRef.current.state.preferencePanel.openedPanelValue;
                  if (panel === GridPreferencePanelsValue.filters) {
                    apiRef.current.hidePreferences();
                  } else {
                    apiRef.current.setFilterModel(filterModel);
                    apiRef.current.showPreferences(GridPreferencePanelsValue.filters);
                    collectGAEvent("buttonClicked", { key: "WorkItemFilters" });
                  }
                },
                startIcon: (
                  <span className="fa-layers fa-fw">
                    <FontAwesomeIcon style={{ height: "18.8px" }} icon={faFilter} />
                    {isFilterOn && (
                      <Box sx={[{ color: "primary.main" }]}>
                        <FontAwesomeIcon
                          icon={faCircle}
                          transform="shrink-10 right-8 up-8"
                          data-testid="filterWarningIcon"
                        />
                      </Box>
                    )}
                  </span>
                ),
              },
            }}
          />
          <Tooltip title="Clear Filters">
            <IconButton
              size={"small"}
              aria-label={"Clear Filter"}
              sx={{ padding: 1, marginLeft: "-3px" }}
              onClick={() => {
                apiRef.current.setFilterModel(initialFilterState);
                setQueryServer(true);
              }}
            >
              <FontAwesomeIcon icon={faFilterSlash} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Apply Filters">
            <Button
              size="medium"
              aria-label="Apply Filters"
              sx={{ padding: 1, borderRadius: 0, ml: 2, outline: "none", border: "none" }}
              variant={hasFilterValues ? "contained" : "outlined"}
              onClick={handleFilterClick}
              disabled={!hasFilterValues || queryServer}
            >
              Apply Filters
            </Button>
          </Tooltip>
          {showMassActionIcons && (
            <>
              <Divider orientation="vertical" sx={{ padding: 1 }} flexItem />
              <Tooltip title="Mark work as cancelled">
                <IconButton
                  size={"small"}
                  aria-label={"Mark work as cancelled"}
                  sx={{ padding: 1, ml: 2 }}
                  onClick={() => {
                    massActionClick!(ActionEnum.CANCEL);
                  }}
                >
                  <FontAwesomeIcon icon={faFolderXmark} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Assign work items">
                <IconButton
                  size={"small"}
                  aria-label={"Assign work items"}
                  sx={{ padding: 1, ml: 2 }}
                  onClick={() => {
                    massActionClick!(ActionEnum.ASSIGN);
                  }}
                >
                  <FontAwesomeIcon icon={faFolderUser} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Mark work as completed">
                <IconButton
                  size={"small"}
                  aria-label={"Mark work as completed"}
                  sx={{ padding: 1, ml: 2 }}
                  onClick={() => {
                    massActionClick!(ActionEnum.COMPLETE);
                  }}
                >
                  <FontAwesomeIcon icon={faFolderCheck} />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      }
    />
  );
}
